export const PTAX_REPORT_STATE = {
    session: ""
}
export const PTAX_ALL_SESSION = [{id: "2024-2025", name: "2024-2025"}, {id: "2025-2026", name: "2025-2026"}]
